import { useState, useEffect } from 'react';

/**
 * Tracks whether the viewport is at or below `maxWidth` (default 899px — the
 * breakpoint where the game screen drops its desktop sidebar in favour of the
 * full-screen Moves / Chat overlays). Updates live on resize / orientation
 * change so the layout switches without a reload.
 */
export function useIsMobile(maxWidth = 899): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
